 
import { Preferences } from '@capacitor/preferences';
import { ASYNC_KEY } from './Constants';
import { format } from "date-fns";
 

export const isAuthenticated = () => {
  return !!localStorage.getItem("userData");
}

export const getAccessToken = async () => {
    return new Promise(async function (resolve, reject) {
      try {

        const value = await Preferences.get({ key: 'isToken'});
        
        if (value !== null) {
          resolve(value?.value);
        } else {
          resolve(null);
        }
      } catch (e) {
        reject(e);
      }
    });
  };
  
  export const setAccessToken = async token => {
    return new Promise(async function (resolve, reject) {
      try {
        const value = await Preferences.set({ key: ASYNC_KEY.accessToken, value: token });
        if (value !== null) {
          resolve(value);
        }
      } catch (e) {
        reject(e);
      }
    });
  };
  

export const getTimeFormat = (time) => {
  return format(new Date(time), "hh:mm a");
}


export const convertedNumTOTime =(num)=>{
  if(num){
    const timeString = num?.toString().padStart(4, '0');
    const dateObj = new Date(`01/01/2000 ${timeString.substr(0, 2)}:${timeString.substr(2)}`);
    const timeFormatted = dateObj.toLocaleTimeString('en-US', { hour12: true, hour: 'numeric', minute: 'numeric' });
    
     return timeFormatted
  }
}